import type { VehicleDetection } from "@visioni/a3s-vehicle-tracker";
import { formatVehicleType } from "@visioni/a3s-vehicle-tracker";

export function isKnown(value: string | null | undefined): value is string {
  return !!value && value.toLowerCase() !== "unknown";
}

export function buildCardTitle(vehicle: VehicleDetection): string {
  const make = isKnown(vehicle.make) ? vehicle.make : null;
  const model = isKnown(vehicle.model) ? vehicle.model : null;
  const color = isKnown(vehicle.color) ? vehicle.color : null;
  const type = formatVehicleType(vehicle.vehicleType);
  const typeKnown = type.toLowerCase() !== "unknown" ? type : null;

  if (make && model) return `${make} ${model}`;
  if (make) return make;
  if (color && typeKnown) return `${color} ${typeKnown}`;
  if (typeKnown) return typeKnown;
  return "Vehicle";
}
